import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TokenService } from '@core/services/token.service';
import { LoginComponent } from '@pages/auth/login/login.component';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthenticationGuard implements CanActivate {


  constructor(private authenticationService: AuthenticationService,
    private router: Router,
	private snackBar: MatSnackBar,
    private tokenService: TokenService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let kontrolNoktasi: any = next.data['kontrolNoktasi'];

    if (window.location.href.includes("guid") && TokenService.url != "" ){
      this.tokenService.set(window.location.href);
      if (TokenService.url != "" ) {
        this.router.navigateByUrl('autologin');
        return false;
      }
      else {
        if (this.authenticationService.isLoggedIn() && this.authenticationService.yetkisiVarMi(kontrolNoktasi)) {
          return true;
        } else {
          this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
          return false;
        }
      }
    }
    else if (this.authenticationService.isLoggedIn()) {
		if(this.authenticationService.yetkisiVarMi(kontrolNoktasi)){
			return true;
		}
		else{
			this.snackBar.open("Yetkiniz olmadığı için ana sayfaya yönlendirildiniz.", null, {
				duration: 3500,
				horizontalPosition: 'right',
				panelClass: 'red-snackbar'
			});
			this.router.navigate([''], { queryParams: { returnUrl: state.url } });
			return false;
		}
    } else {
      this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}
